import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';

export type DateSectionGroups<T> = {
  today: T[];
  yesterday: T[];
  previous: T[];
};

/**
 * Returns true if the given date (local parts) equals the reference date (same year, month, day).
 */
function isSameCalendarDay(y: number, m: number, d: number, ref: Date): boolean {
  return y === ref.getFullYear() && m === ref.getMonth() && d === ref.getDate();
}

/**
 * Groups fragments into three sections by createdAt calendar date (local timezone):
 * today, yesterday, and previous (everything else). Order within each array is preserved.
 */
export function groupFragmentsByDateSection(
  fragments: FragmentListItemDto[],
): DateSectionGroups<FragmentListItemDto> {
  const now = new Date();
  const yesterday = new Date(now.getTime() - 24 * 60 * 60 * 1000);

  const result: DateSectionGroups<FragmentListItemDto> = {
    today: [],
    yesterday: [],
    previous: [],
  };

  for (const fragment of fragments) {
    const d = new Date(fragment.createdAt);
    const y = d.getFullYear();
    const m = d.getMonth();
    const day = d.getDate();

    if (isSameCalendarDay(y, m, day, now)) {
      result.today.push(fragment);
    } else if (isSameCalendarDay(y, m, day, yesterday)) {
      result.yesterday.push(fragment);
    } else {
      result.previous.push(fragment);
    }
  }

  return result;
}
